export default __webpack_public_path__ + "static/media/460.9f35c630.gif";